export const PRIVACY_POLICY_REQUEST_PENDING = 'privacy_policy_pending';
export const PRIVACY_POLICY_REQUEST_RECEIVED = 'privacy_policy_received';
export const PRIVACY_POLICY_REQUEST_ERROR = 'privacy_policy_request_error';
